const ssize = {
	mobileP: 375,
	mobileL: 450,
	tabletP: 767,
	tabletL: 991,
	desktopS: 1200,
	desktopM: 1600,
	desktopL: 2560,
}

export const device = {
	mobileP: ` screen and (max-width: ${ssize.mobileP}px) `,
	mobilePUp: ` screen and (min-width: ${ssize.mobileP + 1}px) `,
	mobileL: ` screen and (min-width: ${ssize.mobileP + 1}px) and (max-width: ${ssize.mobileL}px) `,
	mobile: ` screen and (max-width: ${ssize.mobileL}px) `,
	tabletP: ` screen and (min-width: ${ssize.mobileL + 1}px) and (max-width: ${ssize.tabletP}px) `,
	tabletL: ` screen and (min-width: ${ssize.tabletP + 1}px) and (max-width: ${ssize.tabletL}px) `,
	tablet: ` screen and (min-width: ${ssize.mobileL + 1}px) and (max-width: ${ssize.tabletL}px) `,
	desktopS: ` screen and (min-width: ${ssize.tabletL + 1}px) and (max-width: ${ssize.desktopS}px) `,
	desktopM: ` screen and (min-width: ${ssize.desktopS + 1}px) and (max-width: ${ssize.desktopM}px) `,
	desktopL: ` screen and (min-width: ${ssize.desktopM + 1}px) and (max-width: ${ssize.desktopL}px) `,
	desktopXL: ` screen and (min-width: ${ssize.desktopL + 1}px) `,

	// untuk screen tsb dan lebih kecil
	mobileDown: ` screen and (max-width: ${ssize.mobileL}px) `,
	tabletPDown: ` screen and (max-width: ${ssize.tabletP}px) `,
	tabletDown: ` screen and (max-width: ${ssize.tabletL}px) `,
	desktopSDown: ` screen and (max-width: ${ssize.desktopS}px) `,

	// untuk screen tsb dan lebih besar
	mobileUp: ` screen and (min-width: ${ssize.mobileL + 1}px) `,
	tabletUp: ` screen and (min-width: ${ssize.mobileL + 1}px) `,
	tabletLUp: ` screen and (min-width: ${ssize.tabletP + 1}px) `,
	desktopUp: ` screen and (min-width: ${ssize.tabletL + 1}px) `,
	desktopMUp: ` screen and (min-width: ${ssize.desktopS + 1}px) `,
	desktopLUp: ` screen and (min-width: ${ssize.desktopM + 1}px) `,
}